import { raiseEvent } from '../analytics';
import {
  getClickHeuristics,
  getDomMutationHeuristics,
  getGlobalErrorHandler,
} from '../global-state';

export const watchOnClicks = (root: HTMLElement) => {
  const clicksListener = (event: MouseEvent) => {
    try {
      const targetEl = event.target as HTMLElement;
      if (!targetEl) {
        return;
      }

      for (const heuristic of getClickHeuristics()) {
        const resolved = heuristic(targetEl, event);
        if (resolved) {
          raiseEvent(resolved);
          return;
        }
      }
    } catch (e) {
      console.error(e);
      getGlobalErrorHandler()?.(e);
    }
  };
  root.addEventListener('click', clicksListener, { capture: true });
  return () => {
    root.removeEventListener('click', clicksListener, { capture: true });
  };
};

export const watchBody = (root: HTMLElement) => {
  const observer = new MutationObserver((records) => {
    try {
      const events = [];
      for (const mutation of records) {
        for (const node of mutation.addedNodes) {
          for (const h of getDomMutationHeuristics()) {
            const event = h(node, 'opened');
            if (event) {
              events.push(event);
              break;
            }
          }
        }
        for (const node of mutation.removedNodes) {
          for (const h of getDomMutationHeuristics()) {
            const event = h(node, 'closed');
            if (event) {
              events.push(event);
              break;
            }
          }
        }
      }
      for (const event of events) {
        raiseEvent(event);
      }
    } catch (e) {
      console.error(e);
      getGlobalErrorHandler()?.(e);
    }
  });

  observer.observe(root, {
    childList: true,
    characterData: true,
  });

  return () => observer.disconnect();
};
